export { default } from "./src/single-tab";
export type { UniformSingleTabProps } from "./src/single-tab";
